/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Office_Logo_HintInputs */

const cs_draft_office_logo_hint = /** @type {(inputs: Draft_Office_Logo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bere se z Nastavení → Kancelář. Nemovitosti tímto logem nejsou značeny; v katalozích slouží jen jako hlavička.`)
};

const en_draft_office_logo_hint = /** @type {(inputs: Draft_Office_Logo_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taken from Settings → Office. Properties are not branded by this logo; catalogs use it as letterhead only.`)
};

/**
* | output |
* | --- |
* | "Taken from Settings → Office. Properties are not branded by this logo; catalogs use it as letterhead only." |
*
* @param {Draft_Office_Logo_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_office_logo_hint = /** @type {((inputs?: Draft_Office_Logo_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Office_Logo_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_office_logo_hint(inputs)
	return cs_draft_office_logo_hint(inputs)
});